import { render, staticRenderFns } from "./PostulantEnglishPromotionComponent.vue?vue&type=template&id=40041700&scoped=true&"
import script from "./PostulantEnglishPromotionComponent.vue?vue&type=script&lang=js&"
export * from "./PostulantEnglishPromotionComponent.vue?vue&type=script&lang=js&"
import style0 from "./PostulantEnglishPromotionComponent.vue?vue&type=style&index=0&id=40041700&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40041700",
  null
  
)

export default component.exports